var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreependants(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 368.812,
    height: 288.546,
    viewBox: "0 0 368.812 288.546",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(-1248 -215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    transform: "translate(1422 225)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 278,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 12,
    height: 270,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(1428 332.546) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M0,0,100,50H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M8,12.944V42H66.112L8,12.944M0,0,100,50H0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(1428 419.977) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M0,0,140,50H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M8,11.352V42H93.814L8,11.352M0,0,140,50H0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(1428 503.546) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M0,0,180,50H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M8,10.525V42H121.309L8,10.525M0,0,180,50H0Z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 13,
    height: 34,
    transform: "translate(1449 215) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(1535.788 332.546) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M100,0,0,50H100Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M92,12.944,33.889,42H92V12.944M100,0V50H0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(1575.829 419.977) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M140,0,0,50H140Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M132,11.352,46.186,42H132V11.352M140,0V50H0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(1616.812 503.546) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M180,0,0,50H180Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M172,10.525,58.69,42H172V10.525M180,0V50H0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreependants);
export default __webpack_public_path__ + "static/media/three pendants.990160b857b4a5e4e78a71ed41b8ebce.svg";
export { ForwardRef as ReactComponent };